export default "__VITE_ASSET__BtoSWweb__"